import { Button } from '@mui/material';
import './ErrorComponent.scss';
import { useAppDispatch } from '../../hooks/hooks';
import { resetFilters } from '../../store/filtersSlice';

const ErrorComponent = () => {
  const dispatch = useAppDispatch();
  const reload = () => {
    dispatch(resetFilters());
    window.location.reload();
  };
  return (
    <div className="error-wrapper">
      <h2>Кажется, что-то пошло не так</h2>
      <Button variant="outlined" onClick={reload}>
        Обновить страницу
      </Button>
    </div>
  );
};
export default ErrorComponent;
